<template>
  <div class="headernav">
    <ul>
      <li>
        <WaimoNavigationButton
          v-waimo-notification-badge.secondary.top-right="me.unreadTasks"
          icon="/icons/06-Business-Products/01-Business/briefcase.svg"
          :title="t('header.navigation.tasks')"
          :active="sidePanelState === SidePanelView.TASKS"
          @click="
            () => {
              router.push({
                name: 'TaskDashboard',
              })
              taskStore.fetchNextPage(true)
              sidePanelState = SidePanelView.TASKS
            }
          "
        />
      </li>
      <li>
        <WaimoNavigationButton
          v-waimo-notification-badge.secondary.top-right="unreadChatMessages"
          icon="/icons/21-Messages-Chat-Smileys/02-Messages-Speech-Bubbles/messages-bubble.svg"
          :title="t('header.navigation.chat')"
          :active="sidePanelState === SidePanelView.CHATS"
          @click="sidePanelState = SidePanelView.CHATS"
        />
      </li>
      <li>
        <WaimoNavigationButton
          icon="/icons/07-Work-Office-Companies/06-Office/office-drawer.svg"
          :title="t('header.navigation.lists')"
          :active="sidePanelState === SidePanelView.LISTS"
          @click="sidePanelState = SidePanelView.LISTS"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { WaimoNavigationButton } from '@finetic/waimo-ui'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { useSessionStorage } from '@vueuse/core'
import { SidePanelView } from '@/components/layout/DashboardLayout.vue'
import { useTaskStore } from '@/stores/tasks'
import { useUserStore } from '@/stores/users'
import { useChatStore } from '@/stores/chats'

const { t } = useI18n()
const router = useRouter()

const sidePanelState = useSessionStorage('side-panel', SidePanelView.TASKS)

const userStore = useUserStore()
const { me } = storeToRefs(userStore)

const chatStore = useChatStore()
const { unreadChatMessages } = storeToRefs(chatStore)

const taskStore = useTaskStore()
</script>

<style scoped lang="scss">
.headernav {
  ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
    list-style: none;
    padding: 0;
    margin: 0;
  }
}
</style>
